(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      // Toit de Paris : seulement si la recherche est ouverte. Sinon sa fermeture
      // debloquait le defilement de la page sous une fenetre ouverte (ajout rapide).
      if (this.searchModal && this.searchModal.isOpen()) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tdp-photo-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.tdpPgReady || !root.hasAttribute('data-lightbox')) return;
      root.dataset.tdpPgReady = '1';
      var box = root.querySelector('.tdp-pg__box');
      var big = box.querySelector('.tdp-pg__big');
      var count = box.querySelector('.tdp-pg__count');
      var current = 0;

      function photos() {
        return Array.prototype.slice.call(root.querySelectorAll('.tdp-pg__open'));
      }
      function show(i) {
        var list = photos();
        if (!list.length) return;
        current = (i + list.length) % list.length;
        big.src = list[current].dataset.full;
        big.alt = list[current].dataset.alt || '';
        count.textContent = (current + 1) + ' / ' + list.length;
        var single = list.length < 2;
        box.querySelectorAll('.tdp-pg__nav').forEach(function (b) { b.hidden = single; });
      }
      function close() {
        if (box.open) box.close();
      }

      root.addEventListener('click', function (e) {
        var btn = e.target.closest('.tdp-pg__open');
        if (!btn || !root.contains(btn)) return;
        show(photos().indexOf(btn));
        if (!box.open) box.showModal();
      });
      box.querySelector('.tdp-pg__close').addEventListener('click', close);
      box.querySelector('.tdp-pg__nav--prev').addEventListener('click', function () { show(current - 1); });
      box.querySelector('.tdp-pg__nav--next').addEventListener('click', function () { show(current + 1); });
      // Clic a cote de la photo (sur le fond sombre) : ferme.
      box.addEventListener('click', function (e) {
        if (e.target === box) close();
      });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1); }
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1); }
      });
      // Telephone : glisser vers la gauche / la droite pour changer de photo.
      var startX = null;
      box.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      box.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        startX = null;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
      });
    }

    function initAll() {
      document.querySelectorAll('[data-tdp-photo-grid]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    // Editeur de theme : section ajoutee ou modifiee sans recharger la page.
    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('[data-tdp-photo-grid]');
      if (root) init(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
